const translations = {
  // Navbar
  'nav.about': 'About',
  'nav.packages': 'Packages',
  'nav.calculator': 'Calculator',
  'nav.contacts': 'Contacts',
  'nav.cta': 'Start Investing',

  // Hero
  'hero.badge': 'Seasonal Trend · Spring 2025',
  'hero.title_p1': 'Spring growth of',
  'hero.title_hl': 'corn',
  'hero.title_p2': '— an opportunity to earn on a seasonal trend',
  'hero.desc': 'Historically, corn prices rise in spring due to increased demand from feed producers, bioethanol, and agricultural season preparation. Investors use this seasonal cycle every year.',
  'hero.cta1': 'Calculate profit now',
  'hero.cta2': 'View packages',
  'hero.stat1.val': '+34%',
  'hero.stat1.label': 'Average spring growth',
  'hero.stat2.val': '5+ years',
  'hero.stat2.label': 'Stable trend',
  'hero.stat3.val': 'TOP-3',
  'hero.stat3.label': 'World ag asset',
  'hero.scroll': 'scroll down',
  'hero.chart.title': 'Corn Price Dynamics · Spring',
  'hero.chart.subtitle': 'Indexed growth (Feb = 100%)',
  'hero.chart.maxgrowth': '+38%',
  'hero.chart.maxlabel': 'Maximum seasonal growth',
  'hero.chart.years': '100%',
  'hero.chart.yearslabel': 'Years with positive growth',
  'hero.months.0': 'Feb',
  'hero.months.1': 'Mar',
  'hero.months.2': 'Apr',
  'hero.months.3': 'May',

  // Price Explanation
  'price.badge': 'Seasonal Analytics',
  'price.title_p1': 'Why does corn',
  'price.title_hl': 'grow in spring?',
  'price.subtitle': 'Five key factors forming a stable price trend every year',
  'price.r1.title': 'Livestock Demand',
  'price.r1.desc': 'In spring, demand for feed increases from livestock enterprises preparing for the active season.',
  'price.r1.statLabel': 'demand growth',
  'price.r2.title': 'Sowing Campaign',
  'price.r2.desc': 'The beginning of the active sowing period creates hype on the market and pressure on available stocks.',
  'price.r2.statLabel': 'activity growth',
  'price.r3.title': 'Bioethanol Producers',
  'price.r3.desc': 'Bioethanol plants increase corn purchases for fuel production in the spring season.',
  'price.r3.statLabel': 'purchase growth',
  'price.r4.title': 'Stock Depletion',
  'price.r4.desc': 'By spring, last year\'s stocks are reduced, creating a supply shortage that pushes prices up.',
  'price.r4.statLabel': 'stock remaining',
  'price.r5.title': 'Market Expectations',
  'price.r5.desc': 'The market factors in expectations of the future harvest — uncertainty increases volatility and growth potential.',
  'price.r5.statLabel': 'volatility growth',
  'price.banner.avg': 'Average growth over 5 years',
  'price.banner.desc': 'According to statistics from past years, the spring season is one of the most active growth periods for',
  'price.banner.corn': 'Corn',
  'price.banner.desc2': 'prices.',
  'price.banner.disclaimer': 'Historical data CME Group, USDA · not financial advice',
  'price.banner.years': 'Years with growth (5/5)',

  // Packages
  'pkg.badge': 'Investment Contracts',
  'pkg.title_p1': 'Choose your',
  'pkg.title_hl': 'investment',
  'pkg.title_p2': 'contract',
  'pkg.subtitle': 'Three levels of participation — from start to maximum profit',
  'pkg.start.name': 'Start Contract',
  'pkg.balance.name': 'Balance Contract',
  'pkg.premium.name': 'Premium Contract',
  'pkg.seasonal': 'Corn Investments · 2 days',
  'pkg.investment': 'Investment',
  'pkg.duration': 'Term:',
  'pkg.days': 'days',
  'pkg.yield': 'Yield',
  'pkg.profit': 'Profit:',
  'pkg.cta': 'Start Investing',
  'pkg.popular': 'Popular',
  'pkg.max': 'Maximum',
  'pkg.disclaimer': '* All yield data is based on historical market dynamics. Investments involve risks.',
  'pkg.f.threshold': 'Entry threshold — €{{amount}}',
  'pkg.f.profit': 'Profit {{pct}}% in 2 days',
  'pkg.f.report.monthly': 'Monthly report',
  'pkg.f.report.weekly': 'Weekly report',
  'pkg.f.report.daily': 'Daily report',
  'pkg.f.support.reg': 'Support 5/7',
  'pkg.f.support.prio': 'Priority support',
  'pkg.f.support.vip': 'VIP support 7/7',
  'pkg.f.account': 'Personal account',
  'pkg.f.analytics': 'Market analytics',
  'pkg.f.manager': 'Personal manager',
  'pkg.duration_fixed': 'Fixed term for all contracts',

  // Calculator
  'calc.badge': 'Yield Calculator',
  'calc.title_p1': 'Calculate',
  'calc.title_hl': 'your profit',
  'calc.subtitle': 'Enter parameters and find out the expected income',
  'calc.params': 'Investment Parameters',
  'calc.amount': 'Investment Amount',
  'calc.package': 'Investment Package',
  'calc.dur.label': 'Investment Duration',
  'calc.dur.val': '2 days',
  'calc.dur.fixed': 'Fixed term for all contracts',
  'calc.result': 'Calculation Result',
  'calc.expected': 'Expected Profit',
  'calc.per2days': '% for 2 days',
  'calc.total': 'Total Amount',
  'calc.invested': 'Investment',
  'calc.pkg.label': 'Package',
  'calc.period': 'Period',
  'calc.period.val': '2 days',
  'calc.bar.invested': 'Invested',
  'calc.bar.profit': 'Profit',
  'calc.cta': 'Choose a Contract',

  // Activity
  'activity.header': 'Platform Activity',
  'activity.invested': 'invested',
  'activity.profit': 'earned profit',
  'activity.just_now': 'just now',
  'activity.1min': '1 min ago',
  'activity.2min': '2 min ago',
  'activity.3min': '3 min ago',
  'activity.disclaimer': 'real-time demonstration of platform user activity',
  'activity.badge': 'Investor Community',
  'activity.title_p1': 'Thousands of investors already',
  'activity.title_hl': 'earning with us',
  'activity.desc': 'Every day our clients earn profits from corn\'s seasonal trend. Join thousands of investors who use this cycle annually.',
  'activity.stat1': 'Active Investors',
  'activity.stat2': 'Assets Under Management',
  'activity.stat3': 'Satisfied Clients',
  'activity.join': 'Join',
  'activity.view': 'View packages',

  // Toast
  'toast.earned': 'just earned',

  // Trust
  'trust.badge': 'Why They Trust Us',
  'trust.title_p1': 'Reliability proven by',
  'trust.title_hl': 'time',
  'trust.subtitle': 'Corn is one of the most liquid and predictable agricultural assets in the world',
  'trust.item1.title': 'Oldest Trading Instrument',
  'trust.item1.desc': 'Investments in agricultural commodity markets are one of the oldest seasonal trading instruments — proven by centuries of market history.',
  'trust.item2.title': 'TOP-3 World Ag Assets',
  'trust.item2.desc': 'Corn is in the top-3 global agricultural assets by trading volume and liquidity on CME and CBOT exchanges.',
  'trust.item3.title': 'Increased Spring Volatility',
  'trust.item3.desc': 'The spring season historically shows increased volatility and growth potential, creating unique opportunities for investors.',
  'trust.stat1.label': 'years of market history',
  'trust.stat2.label': 'annual trading volume',
  'trust.stat3.label': 'among ag assets',
  'trust.stat4.label': 'position liquidity',
  'trust.cta.desc': 'Ready to take advantage of the spring trend? Calculate your potential profit right now.',
  'trust.cta.btn': 'Calculate profit now',

  // Footer
  'footer.tagline': '— Seasonal Corn Investments',
  'footer.about': 'About',
  'footer.packages': 'Packages',
  'footer.calculator': 'Calculator',
  'footer.disclaimer': '© 2025 CornVest. Not investment advice.',
};

export default translations;
